/* tslint:disable */
/* eslint-disable */
/**
 * cellera-backend API spec
 * Backend Service for Cellera | [swagger.json](cellera/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GenerateInstructionDto
 */
export interface GenerateInstructionDto {
    /**
     * Free text instruction content to feed into Gemini generation
     * @type {string}
     * @memberof GenerateInstructionDto
     */
    freeText?: string;
    /**
     * Invoice file URL (GCS URI or signed URL) to feed into Gemini generation
     * @type {string}
     * @memberof GenerateInstructionDto
     */
    invoiceFileUrl?: string;
    /**
     * Patient ID (required - for associating instruction with a patient)
     * @type {string}
     * @memberof GenerateInstructionDto
     */
    patientId: string;
}

/**
 * Check if a given object implements the GenerateInstructionDto interface.
 */
export function instanceOfGenerateInstructionDto(value: object): value is GenerateInstructionDto {
    if (!('patientId' in value) || value['patientId'] === undefined) return false;
    return true;
}

export function GenerateInstructionDtoFromJSON(json: any): GenerateInstructionDto {
    return GenerateInstructionDtoFromJSONTyped(json, false);
}

export function GenerateInstructionDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): GenerateInstructionDto {
    if (json == null) {
        return json;
    }
    return {
        
        'freeText': json['freeText'] == null ? undefined : json['freeText'],
        'invoiceFileUrl': json['invoiceFileUrl'] == null ? undefined : json['invoiceFileUrl'],
        'patientId': json['patientId'],
    };
}

export function GenerateInstructionDtoToJSON(json: any): GenerateInstructionDto {
    return GenerateInstructionDtoToJSONTyped(json, false);
}

export function GenerateInstructionDtoToJSONTyped(value?: GenerateInstructionDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'freeText': value['freeText'],
        'invoiceFileUrl': value['invoiceFileUrl'],
        'patientId': value['patientId'],
    };
}

